var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ContestEntryFormLayout,
    {
      attrs: {
        "load-state": _setup.loadState,
        "error-message": _setup.t("contestEntryForm.step1.loadError"),
        "current-step": 1,
        title: _setup.t("contestEntryForm.step1.title"),
        description: _setup.t("contestEntryForm.step1.description"),
        contest: _setup.microCmsContest,
      },
    },
    [
      _c(_setup.ContestEntryApplicantInfoForm, {
        attrs: { "penname-options": _setup.pennameOptions },
        on: { "add-penname": _setup.onAddPenname },
        model: {
          value: _setup.form,
          callback: function ($$v) {
            _setup.form = $$v
          },
          expression: "form",
        },
      }),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "button",
          {
            staticClass: "next-button",
            attrs: { type: "button", disabled: !_setup.canProceed },
            on: { click: _setup.onClickNext },
          },
          [_vm._v(" " + _vm._s(_setup.t("contestEntryForm.step1.next")) + " ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }